export const academyPaymentMethods = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank transfer' },
  { value: 'card', label: 'Card' },
  { value: 'visa', label: 'Visa' },
  { value: 'wish', label: 'Wish' },
  { value: 'omt', label: 'OMT' },
  { value: 'neo', label: 'Neo' },
  { value: 'other', label: 'Other' },
];

export const paymentMethodLabel = value =>
  academyPaymentMethods.find(method => method.value === value)?.label
  || (value === 'cheque' ? 'Cheque' : String(value || '—').replace(/_/g, ' '));
